// API authentication exports
import jwt from 'jsonwebtoken';
import type { JwtPayload } from '../types/index.js';

const JWT_SECRET = process.env.JWT_SECRET || 'dev-secret-key';

export function generateToken(payload: Omit<JwtPayload, 'iat' | 'exp'>, expiresIn = '7d'): string {
  return jwt.sign(payload, JWT_SECRET, { expiresIn });
}

export function verifyToken(token: string): JwtPayload | null {
  try {
    return jwt.verify(token, JWT_SECRET) as JwtPayload;
  } catch {
    return null;
  }
}

export function extractBearerToken(authHeader?: string): string | null {
  if (!authHeader?.startsWith('Bearer ')) return null;
  return authHeader.slice(7);
}

export const rateLimits = {
  free: { requests: 100, window: 3600000 }, // 100 requests per hour
  premium: { requests: 1000, window: 3600000 }, // 1000 requests per hour  
  admin: { requests: 10000, window: 3600000 } // 10k requests per hour
} as const;